import { IAppState } from '../../../AppModulesWrapper';

import { selectIsPublicationAvailable, selectIsPublishButtonPending } from '.';
import { selectIsSaveDraftPending } from '../draft';
import { selectServiceUnavailableReason } from '../publishTerms';

export const selectIsPublishButtonDisabled = (state: IAppState): boolean => {
  const isPublishButtonPending = selectIsPublishButtonPending(state);
  const isPublicationAvailable = selectIsPublicationAvailable(state);
  const isSaveDraftPending = selectIsSaveDraftPending(state);
  const unavailableReason = selectServiceUnavailableReason(state);

  return (
    isPublishButtonPending ||
    isSaveDraftPending ||
    // Если публикация недоступна, но под услугами есть ошибка, кнопку блокировать не нужно, т.к. при клике на нее скролим к ошибке
    (!isPublicationAvailable && !unavailableReason)
  );
};
